module.exports = __webpack_public_path__ + "static/media/secure.03572658.png";